import { useIntl } from "react-intl";

import { Chip } from "@/components/Chip/Chip";
import { Divider } from "@/components/Divider/Divider";
import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";
import type { HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
};

export const HotelFacilities = ({ hotel }: Props) => {
  const intl = useIntl();

  const facilities = hotel.descriptions?.facilities?.split(",");

  if (!facilities) return null;

  return (
    <>
      <div className="my-4">
        <Divider color="neutral-soft" />
      </div>
      <div className="mb-4 font-medium text-text-tertiary">
        {intl.formatMessage({
          defaultMessage: "Facilities",
          description: "Section heading for hotel facilities and amenities",
        })}
      </div>
      <ExpandableSection>
        <ul className="flex flex-wrap gap-2">
          {facilities.map((facility) => (
            <li key={facility}>
              <Chip
                label={facility}
                color="neutral-soft"
                size="medium"
                maxWidth="full"
              />
            </li>
          ))}
        </ul>
      </ExpandableSection>
    </>
  );
};
